/**
 * Created by Jaime Bonilla Venegas on 2017-06-19.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Item } from './components';
import Form from '../../forms';
import * as actions from './actions';
import { SubHeader, EmptyList } from '../../components/layout';
import { UsuariosFilter } from '../../components/filters';
import { serializeParams } from '../../common/helpers';
import { getPagePermissions, USERS_PERMISSION } from '../../security/permissions';
import Snackbar from 'material-ui/Snackbar';


class Users extends Component {

    componentWillMount() {
        this.props.fetchData('users', 'users', 'users?projection=usersProjection&page=0&size=500');
    }

    formHandler(open, path, form) {
        this.props.notify({ op: 'update', path: 'formOpen', value: open });
        switch (path) {
            case 'NEW_USER':
                this.props.saveUser(form);
                break;
            default:
        }
    }

    CreateURL(table, filter, projection) {
        console.log(table.concat(filter).concat(projection));
        return (table.concat(filter).concat(projection));
    }

    render() {
        const { formOpen, notify, users, pagePermissions, showNotification = false, showMessage = "", notificationColor } = this.props;
        return (
            <div>
                <SubHeader
                    title="Usuarios"
                    showRefresh={false}
                    onPressHeaderButton={() => this.formHandler(true)}
                    showAddButton={pagePermissions.create}
                />
                <div className="navbar visible-xs" style={{ padding: '0rem 2.3rem' }}>
                    <button
                        className="btn btn-default navbar-btn btn-filtros"
                        data-toggle="collapse" data-target="#filter-sidebar"
                    >
                        <i className="fa fa-tasks" /> Panel de filtros
                    </button>
                </div>
                <div>
                    <UsuariosFilter
                        onSearch={(params) => {
                            Object.keys(params).forEach(key => params[key] === "" ? delete params[key] : '');
                            this.props.fetchData('users', 'users', this.CreateURL('users', serializeParams(params), '&projection=usersProjection'));
                        }}
                        onClear={(params) => {
                            this.props.fetchData('users', 'users', 'users?projection=usersProjection');
                        }}
                        isEmpty={users.length === 0}
                    >
                        {
                            users.length === 0 ? <EmptyList /> :
                            users.map((user, index) => {
                                return (
                                    <Item
                                        key={index}
                                        user={user}
                                        allowUpdate={pagePermissions.update}
                                        allowDelete={pagePermissions.delete}
                                        onSave={(newUser) => {
                                            //This is only updating the item on memory
                                            //Replace this with the action that saves results on server
                                            this.props.editUser(newUser.user, index);
                                        }} />
                                );
                            })
                        }
                    </UsuariosFilter>
                </div>
                <Form
                    title="Nuevo Usuario"
                    type="user"
                    open={formOpen}
                    actions={{}}
                    onModalClosed={() => this.formHandler(false, 'openForm')}
                    onSave={(form) => {
                        this.formHandler(false, 'NEW_USER', form);
                    }}//Will return if form is valid to send it
                />

                <Snackbar
                    bodyStyle={{
                        top: 0,
                        bottom: 'auto',
                        backgroundColor: notificationColor,
                        maxWidth: "800px",
                        height: "55px",
                        lineHeight: "28px",
                        left: (window.innerWidth - 288) / 2,
                        /*transform: this.props.errorMessage ?
                          'translate3d(0, 0, 0)' :
                          "translate3d(0, "+ -(window.innerHeight - 100) + "px , 0)"*/
                    }}
                    open={showNotification}
                    message={showMessage}
                    autoHideDuration={4000}
                    onRequestClose={() => this.props.notify({ op: 'update', path: 'showNotification', value: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ users, userData, userData: { permissions } }) => {
    return {
        ...users,
        userData,
        pagePermissions: getPagePermissions(USERS_PERMISSION, permissions)
    };
};


export default connect(mapStateToProps, { ...actions })(Users);



// WEBPACK FOOTER //
// ./containers/users/index.js